import { type FC } from 'react';
import { useHistory } from 'react-router-dom';

import { useBankDetailsEdition } from 'common/hooks/useBankDetailsEdition';
import BackButton from 'components/BackButton';
import Loader from 'components/Loader';
import { UserBankDetailsFormSchema } from 'components/UserBankDetailsForm/schema';
import * as Layout from 'layouts/StickyStepperLayout';

import * as routes from '../../routes';
import { EditBankDetailsForm } from './components/EditBankDetailsForm';

export const EditBankDetails: FC = () => {
  const history = useHistory();
  const { data, loading, saveBankDetails, saving } = useBankDetailsEdition();
  const recipientInformation: UserBankDetailsFormSchema = data
    ? {
        country: data.iban.slice(0, 2),
        iban: data.iban,
        name: data.recipientName,
        swiftBic: data.swiftBic,
      }
    : {
        country: 'FR',
        iban: '',
        name: '',
        swiftBic: '',
      };

  const saveFormBankDetails = ({
    iban,
    name,
    swiftBic,
  }: UserBankDetailsFormSchema) => {
    saveBankDetails({
      iban,
      recipientName: name,
      swiftBic,
    }).then(() => history.push(routes.root));
  };

  return (
    <Layout.Root>
      <Layout.Body>
        <Layout.HeaderButtonsContainer width="auto">
          <BackButton to={routes.root} />
        </Layout.HeaderButtonsContainer>
        {loading ? (
          <Loader />
        ) : (
          <EditBankDetailsForm
            defaultValues={recipientInformation}
            isSaving={saving}
            onSubmit={(submittedData) => {
              saveFormBankDetails(submittedData);
            }}
          />
        )}
      </Layout.Body>
    </Layout.Root>
  );
};
